import { useGetLanguage } from 'hooks/useGetLanguage'
import styles from './Terms.module.scss'
import { TermsProps } from 'features/terms/types'

const Terms = ({ content }: TermsProps) => {
  // i18n
  const language = useGetLanguage()

  return <section className={styles.terms}>{content[language]}</section>
}

export default Terms
